import { Box } from '@mui/material';
import HeaderNotifications from './Notifications';

function HeaderButtons({ notifications, fetchNotification }) {
  return (
    <Box sx={{ mr: 1, display: 'flex' }}>
      {/*       <HeaderSearch />
       */}{' '}
      <HeaderNotifications
        notifications={notifications}
        fetchNotification={fetchNotification}
      />
    </Box>
  );
}

export default HeaderButtons;
